import { render, staticRenderFns } from "./titleAndDescriptionDialog.vue?vue&type=template&id=fd23d2a6"
import script from "./titleAndDescriptionDialog.vue?vue&type=script&lang=js"
export * from "./titleAndDescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports